{
  "title": "Tasks",
  "newTask": "New task",
  "addTask": "Add task",
  "kind": {
    "task": "Task",
    "epic": "Epic",
    "tasks": "Tasks",
    "noTasks": "No tasks yet",
    "progress": "{{done}}/{{total}}"
  },
  "empty": "No tasks",
  "unnamed": "Unnamed",
  "aiGenerated": "AI",
  "aiGeneratedHint": "Written by AI on this person's behalf",
  "allProjects": "All projects",
  "projectSearch": "Find a project",
  "memberSearch": "Find an assignee",
  "epicSearch": "Find an epic",
  "searchEmpty": "Nothing found",
  "moveFailed": "Could not move the task",
  "switcherAria": "Choose a project",
  "filter": {
    "label": "Filter tasks",
    "all": "All tasks",
    "roles": {
      "assignee": "Assignee",
      "author": "Author"
    },
    "mine": {
      "assignee": "My tasks",
      "author": "Created by me"
    },
    "search": {
      "assignee": "Find an assignee",
      "author": "Find an author"
    },
    "authoredBy": "Author: {{name}}"
  },
  "overdue": "Overdue",
  "columns": {
    "todo": "To do",
    "in_progress": "In progress",
    "review": "In review",
    "done": "Done"
  },
  "dialog": {
    "createTitle": "New task",
    "title": "Title",
    "description": "Description",
    "status": "Status",
    "assignee": "Assignee",
    "noAssignee": "No assignee",
    "agent": "Agent",
    "asset": "Asset",
    "kind": "Type",
    "epic": "Epic",
    "noEpic": "No epic",
    "noAsset": "No asset",
    "assetLoadFailed": "Could not load assets",
    "project": "Project",
    "projectPlaceholder": "Choose a project",
    "projectRequired": "Pick a project first",
    "create": "Create",
    "delete": "Delete",
    "deleteTitle": "Delete the task?",
    "deleteMessage": "“{{title}}” will be deleted permanently.",
    "author": "Author",
    "createdAt": "Created",
    "editedAt": "edited {{time}} by {{name}}",
    "saveFailed": "Could not save the task",
    "deleteFailed": "Could not delete the task",
    "loadFailed": "Could not load the task",
    "notFound": "Task not found: it was deleted or the project prefix changed",
    "titlePlaceholder": "Task title",
    "descriptionPlaceholder": "Add a description…",
    "noDescription": "No description",
    "dueDate": "Due date",
    "noDueDate": "No due date",
    "clearDueDate": "Clear due date",
    "actions": "Actions",
    "copyLink": "Copy link",
    "linkCopied": "Link copied",
    "copyFailed": "Could not copy the link",
    "addDescription": "Add a description",
    "editDescription": "Edit description",
    "saveDescription": "Save",
    "cancelEdit": "Cancel",
    "unsavedTitle": "Leave without saving?",
    "unsavedMessage": "Your changes to the description will not be saved.",
    "discard": "Leave without saving",
    "overwrote": "While you were editing, {{name}} changed the description — their version is in the history",
    "overwroteSelf": "While you were editing, the description was saved in another window — the previous version is in the history",
    "pagerPosition": "{{index}} of {{total}}",
    "pagerPrev": "Previous task",
    "pagerNext": "Next task"
  },
  "assetPick": {
    "character": "Epic for the character",
    "location": "Epic for the location",
    "prop": "Epic for the prop",
    "shot": "Epic for the shot",
    "script": "Epic for the script",
    "label": "Epic",
    "new": "Create a new one",
    "continue": "Continue"
  },
  "asset": {
    "loading": "Loading…",
    "search": {
      "character": "Find a character",
      "location": "Find a location",
      "prop": "Find a prop"
    },
    "empty": {
      "character": "The project has no characters yet",
      "location": "The project has no locations yet",
      "prop": "The project has no props yet"
    }
  },
  "assetKind": {
    "none": "No asset",
    "character": "Character",
    "location": "Location",
    "prop": "Prop",
    "shot": "Shot",
    "script": "Script"
  },
  "agent": {
    "shotMissing": "pick a shot",
    "shotSearch": "Find a shot",
    "shotsLoading": "Loading shots…",
    "shotsLoadFailed": "Could not load shots",
    "noShots": "The project has no shots yet",
    "episode": "Episode {{label}}",
    "scene": "Scene {{label}}",
    "shot": "Shot {{label}}"
  },
  "delegation": {
    "button": "Hand off to agent",
    "hintShot": "Pick a shot for the shot assistant",
    "hintDescription": "Save the description first",
    "title": "Hand off to agent · {{key}}",
    "description": "{{agent}} will get this prompt on your behalf. The tasks assistant prepared it — review and edit it if needed.",
    "preparing": "The tasks assistant is preparing the prompt…",
    "prepareFailed": "Could not prepare the prompt",
    "retry": "Retry",
    "fallback": "The discussion could not be summarized automatically, so the prompt contains the comments themselves, leadership first. Review them before sending.",
    "promptLabel": "Prompt for the agent",
    "send": "Send",
    "sent": "Task handed off: {{agent}}",
    "alreadySent": "This prompt has already been sent",
    "failed": "Could not hand off the task"
  },
  "editor": {
    "toolbar": "Formatting",
    "bold": "Bold",
    "italic": "Italic",
    "strike": "Strikethrough",
    "code": "Code",
    "heading": "Heading",
    "bulletList": "Bulleted list",
    "orderedList": "Numbered list",
    "quote": "Quote",
    "table": "Table",
    "addRow": "Add row",
    "addColumn": "Add column",
    "deleteRow": "Delete row",
    "deleteColumn": "Delete column",
    "deleteTable": "Delete table"
  },
  "files": {
    "title": "Files",
    "library": "Library",
    "fromComputer": "Upload a file",
    "fromLibrary": "From Library",
    "attach": "Attach",
    "open": "Open",
    "remove": "Remove",
    "removeTitle": "Remove file?",
    "removeMessage": "File “{{name}}” will be removed from the task.",
    "removeMentioned": "File “{{name}}” is mentioned in the description. It will be removed from the task and the link to it will stop working.",
    "removeMentionedInComments": "File “{{name}}” is mentioned in the comments. It will be removed from the task and the link to it will stop working.",
    "uploadFailed": "Could not upload the file",
    "removeFailed": "Could not remove the file",
    "libraryPartial": "Could not attach: {{names}}",
    "uploading": "Uploading…",
    "waitUploads": "Wait for the files to finish uploading",
    "dropHint": "Drop files or click to browse",
    "dropOverlay": "Drop to attach to {{key}}",
    "dropOverlayNew": "Drop to attach to the new task",
    "folderSkipped": "Folders can’t be attached — drop the files themselves"
  },
  "draft": {
    "projectLocked": "To change the project, remove: {{reasons}}",
    "lockLibraryFiles": "Library files",
    "lockPeople": "people mentions",
    "lockEntities": "character, location and prop mentions",
    "lockShot": "the shot assistant’s shot",
    "saveTitle": "Keep the draft?",
    "saveMessage": "The title, description and files will stay in the draft, and the form will open with them next time.",
    "save": "Keep",
    "delete": "Delete",
    "saveFailed": "Could not save the draft",
    "deleteFailed": "Could not delete the draft",
    "tooManyFiles": "A draft holds at most {{max}} files",
    "uploadsTooLarge": "Files from the computer in a draft add up to {{max_mb}} MB at most",
    "removeMessage": "File “{{name}}” will be removed from the draft.",
    "removeMentioned": "File “{{name}}” is mentioned in the description. It will be removed from the draft and the link to it will stop working."
  },
  "comments": {
    "title": "Comments",
    "placeholder": "Leave a comment…",
    "send": "Send",
    "attach": "Attach file",
    "edited": "edited",
    "edit": "Edit",
    "save": "Save",
    "delete": "Delete",
    "deleteTitle": "Delete comment?",
    "deleteMessage": "The comment will be deleted permanently.",
    "loadFailed": "Could not load comments",
    "sendFailed": "Could not send the comment",
    "saveFailed": "Could not save the comment",
    "deleteFailed": "Could not delete the comment",
    "loadingOlder": "Loading earlier comments…"
  },
  "history": {
    "title": "Description history",
    "versions": "Description versions",
    "current": "Current",
    "showChanges": "Show changes",
    "restore": "Restore this version",
    "empty": "The description is empty",
    "loading": "Loading…",
    "loadFailed": "Could not load the description history",
    "restoreFailed": "Could not restore the version",
    "tooLargeForDiff": "The versions are too long to highlight the changes"
  },
  "board": {
    "loadingMore": "Loading tasks…",
    "loadFailed": "Could not load tasks",
    "search": {
      "placeholder": "Search tasks",
      "hint": "Searches key, title and description",
      "tooShort": "Type at least two characters or a task number",
      "clear": "Clear search"
    }
  },
  "mentions": {
    "taskNoAccess": "no access",
    "taskDeleted": "task deleted",
    "taskSearchHint": "Type 3 characters to find a task",
    "taskSearching": "Searching tasks…",
    "openPerson": "Open in Team",
    "openTask": "Open task",
    "heroDeleted": "character deleted",
    "locDeleted": "location deleted",
    "propDeleted": "prop deleted",
    "outfitDeleted": "outfit deleted",
    "variantDeleted": "variant deleted",
    "stateDeleted": "state deleted",
    "openHero": "Open in Characters",
    "openLoc": "Open in Locations",
    "openProp": "Open in Props",
    "shotDeleted": "shot deleted",
    "scriptDeleted": "script deleted",
    "openShot": "Open the shot in the storyboard",
    "openScript": "Open script"
  }
}
